import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "@tanstack/react-router";
import {
  Blocks,
  Building2,
  ChevronLeft,
  ChevronRight,
  PanelLeft,
  Settings,
  ShieldCheck,
  UserRound,
} from "lucide-react";
import { getSettingsItems } from "@core/settings/settings-registry";

const iconMap = { Blocks, Building2, PanelLeft, ShieldCheck, UserRound };

export function SettingsLayout() {
  const location = useLocation();
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = React.useState(false);
  const items = getSettingsItems();
  const current = items.find((item) => location.pathname.startsWith(item.path));

  return (
    <div className={`settings-workspace ${collapsed ? "settings-sidebar-collapsed" : ""}`}>
      <div className="settings-mobile-heading">
        <Settings aria-hidden="true" />
        <select
          aria-label="Settings section"
          value={current?.path ?? "/settings"}
          onChange={(event) => navigate({ to: event.target.value })}
        >
          <option value="/settings">Settings overview</option>
          {items.map((item) => <option key={item.id} value={item.path}>{item.label}</option>)}
        </select>
      </div>

      <aside className="settings-sidebar" aria-label="Settings navigation">
        <button
          className="settings-sidebar-header"
          type="button"
          onClick={() => setCollapsed((value) => !value)}
          aria-label={collapsed ? "Expand settings navigation" : "Collapse settings navigation"}
          title={collapsed ? "Expand settings navigation" : "Collapse settings navigation"}
        >
          <span className="settings-sidebar-header-icon" aria-hidden="true">
            <Settings />
            {collapsed && <span className="settings-sidebar-collapse-indicator"><ChevronRight /></span>}
          </span>
          {!collapsed && <strong>Settings</strong>}
          {!collapsed && <ChevronLeft className="settings-sidebar-header-chevron" aria-hidden="true" />}
        </button>
        <nav>
          {items.map((item) => {
            const Icon = iconMap[item.icon] ?? Settings;
            const active = location.pathname.startsWith(item.path);
            return (
              <Link key={item.id} to={item.path} className={active ? "is-active" : ""} title={collapsed ? item.label : undefined}>
                <Icon aria-hidden="true" />
                {!collapsed && <span>{item.label}</span>}
                {!collapsed && active && <ChevronRight className="settings-nav-chevron" aria-hidden="true" />}
              </Link>
            );
          })}
        </nav>
      </aside>
      <section className="settings-content">
        <Outlet />
      </section>
    </div>
  );
}
